/* ZEPHIR - Cajon del carrito: envio gratis, recomendados con anadir rapido, y
 * sin casilla de T&C. Estilos y redisenno en assets/zephir-cart.css.
 *
 * POR QUE SE INYECTA Y NO SE EDITA LA SECCION: sections/mini_cart.liquid pesa
 * 47,6 KB, por encima del tope por llamada de la via que tengo para escribir
 * archivos de tema. Ademas el cajon vive en el layout, asi que es global y aqui
 * se alcanza igual.
 *
 * ================= LO QUE SE APRENDIO A GOLPES =================
 *
 * 0. HAY TRES VIAS PARA QUE ESTO ARRANQUE Y ES A PROPOSITO: al cargar la pagina,
 *    al cambiar las clases del cajon, y al hacer clic en algo que lleve al
 *    carrito. Se probo dejar solo la segunda -- "no hacer nada hasta que abran
 *    el cajon" -- y no se pinto NADA nunca, porque la deteccion de la apertura
 *    no era fiable. Cuando la unica puerta de entrada puede fallar, no puede ser
 *    la unica puerta de entrada.
 *
 * 1. EL CAJON NO SE REFRESCA SOLO, Y ESO ERA EL FALLO DE FONDO. Medido: con el
 *    carrito real en 3 articulos / $767.900, el cajon seguia mostrando 2 filas y
 *    $508.000. De ahi salian LOS DOS sintomas que se veian como distintos:
 *      - "el valor del envio sale mal": no salia mal. Mi barra leia /cart.js (el
 *        carrito de verdad) y las filas de al lado eran viejas, asi que los
 *        numeros no cuadraban entre si y se lee como que la barra miente.
 *      - "anado desde el carrito y no lo suma hasta cerrar y abrir": el articulo
 *        entraba siempre; lo que no se enteraba era la lista.
 *    Por eso el cajon SE AUTOCORRIGE: se compara lo que hay pintado con /cart.js
 *    y, si no coinciden, se pide el cajon al servidor. Da igual quien movio el
 *    carrito (la ficha, "Arma tu look", otra pestana).
 *
 * 2. SI SE PIDE EL CAJON, SE PIDE POR SECCION: /?sections=mini_cart.
 *    ESTO CORRIGE UNA NOTA EQUIVOCADA QUE HABIA AQUI. Decia que el mini-cart no
 *    era una seccion y que la Section Rendering API no servia; si sirve
 *    (comprobado: devuelve el cuerpo entero del cajon, ~11 KB, con
 *    .t4s-drawer__wrap y sus filas). Lo que se hacia antes -- traerse la PAGINA
 *    COMPLETA y copiar de ahi el cajon -- estaba mal de raiz: en una ficha de
 *    producto el cajon NO viene renderizado en el HTML de la pagina, asi que se
 *    copiaba un cajon VACIO encima del bueno. Eso es exactamente "le di anadir y
 *    no aparecio hasta que cerre y abri".
 *    /cart/add.js acepta ademas sections en el cuerpo y devuelve el cajon ya
 *    renderizado en la misma respuesta: cuando se anade desde aqui no hace falta
 *    una segunda peticion.
 *
 * 3. NO SE USA T4SThemeSP.Cart.renderContents. Existe, pero lanza
 *    "Cannot read properties of undefined (reading 'split')" si no se le pasa la
 *    respuesta con la forma que espera, y la lista de secciones se la da
 *    getToFetch(), que aqui devuelve undefined. Depender de eso es depender de
 *    codigo minificado ajeno; se hace el reemplazo a mano.
 *
 * 4. EL PARPADEO ERA UN BUCLE ENTRE ESTE CODIGO Y EL TEMA. El observador
 *    vigilaba todo el interior del cajon (subtree). El cargador de imagenes del
 *    tema (lazysizes) toca DENTRO DE MIS PROPIAS FOTOS de recomendados; eso
 *    contaba como cambio ajeno, repintaba, y al reconstruirse la fila su
 *    scrollLeft volvia a 0: de ahi tambien el "no deja hacer scroll".
 *    Se corta por tres lados y HAY QUE MANTENER LOS TRES:
 *      a) FIRMA de estado: si el carrito no cambio, no se repinta.
 *      b) Se actualiza EN EL SITIO; nunca se borra y recrea algo que ya esta bien.
 *      c) Los observadores miran solo HIJOS DIRECTOS, nunca subtree.
 *
 * 5. LOS OBSERVADORES SE VUELVEN A COLGAR EN CADA REFRESCO. Se colgaban una vez
 *    al arrancar; cuando el tema reemplazaba el cuerpo del cajon, quedaban en
 *    nodos desconectados y no volvian a saltar nunca. Resultado: la barra se
 *    pintaba, el tema rehacia el cajon, se la llevaba, y ya no volvia. Ahora
 *    vigilar() los reengancha (idempotente con un WeakSet) y ademas hay un
 *    repaso acotado al abrir -- tres comprobaciones, y solo escriben si falta
 *    algo, asi que no pueden hacer titilar nada.
 *    CUIDADO: revivir los observadores revive tambien cualquier ida y vuelta con
 *    el tema que antes se cortaba solo porque el observador estaba muerto. De
 *    ahi el presupuesto (TOPE_REFRESCOS) y que la casilla de T&C ya no lance
 *    eventos (ver sinTerminos).
 *
 * 6. EL CONTENIDO DEL CAJON VA Y VIENE. En el home existe al cargar; en una
 *    ficha NO (comprobado a los 4 y a los 14 segundos) y aparece al abrirlo. Por
 *    eso hay que poder pintar en cualquier momento, no solo al arrancar.
 *
 * 7. EL BOTON DE PAGO NUNCA ESTA DESHABILITADO. Es un <button name="checkout"> y
 *    su estado no cambia con la casilla de T&C, asi que la validacion (si la hay)
 *    ocurre al enviar. Por eso la casilla no solo se oculta: se marca por debajo.
 *
 * 8. LOS VISTOS DEL TEMA NO SIRVEN PARA PINTAR. localStorage['nt_recent'] trae
 *    IDs de producto y Shopify no expone endpoint publico para resolver un ID.
 *    Se lleva lista propia (zph_vistos) con lo justo para pintar Y SUS VARIANTES.
 *
 * Moneda en es-CO (puntos de millar) porque es la que ya usa el cajon: $289.000.
 */
(function () {
  'use strict';

  var yo = document.querySelector('script[src*="zephir-cart"]');
  var META = 30000000;                       // centavos; se sobreescribe abajo
  if (yo && yo.getAttribute('data-goal')) {
    var g = parseInt(yo.getAttribute('data-goal'), 10);
    if (!isNaN(g) && g > 0) META = g * 100;  // el ajuste va en pesos
  }
  var TOPE_VISTOS = 12;
  var CLAVE = 'zph_vistos';
  var SECCION = 'mini_cart';

  function plata(cent) {
    return '$' + Math.round(cent / 100).toLocaleString('es-CO');
  }
  /* 2026-10-06: TALLA Y COLOR POR NOMBRE DE OPCION. En los productos fusionados
   * la opcion 1 es Color y la 2 Talla; leerlas por posicion ponia colores en el
   * selector de talla. Y el precio puede venir en centavos (endpoints .js y
   * recomendaciones) o en pesos como texto (/products.json): se normaliza. */
  function idxOpciones(pd) {
    var n = (pd.options || []).map(function (o) {
      return String(typeof o === 'string' ? o : (o && o.name) || '').toLowerCase();
    });
    var ti = n.indexOf('talla');
    if (ti < 0) ti = n.indexOf('size');
    return { ti: ti, ci: n.indexOf('color') };
  }
  function aCent(v) {
    if (typeof v === 'number') return Math.round(v);
    var f = parseFloat(String(v || '').replace(/[^0-9.]/g, ''));
    return isNaN(f) ? 0 : Math.round(f * 100);
  }
  function aVariante(v, ix) {
    var ops = v.options || [v.option1, v.option2, v.option3];
    return { i: v.id, s: ix.ti >= 0 ? ops[ix.ti] : v.option1, c: ix.ci >= 0 ? ops[ix.ci] : v.option2,
             a: v.available, p: v.price };
  }
  function leerVistos() {
    try { return JSON.parse(localStorage.getItem(CLAVE) || '[]') || []; }
    catch (e) { return []; }
  }
  function disponibles(p) {
    return (p.v || []).filter(function (x) { return x.a; });
  }

  /* --- registro de lo que el visitante mira ----------------------------- */
  function anotarVisto() {
    if (location.pathname.indexOf('/products/') !== 0) return;
    var handle = location.pathname.split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('#')[0].split('/')[0];
    if (!handle) return;

    var lista = leerVistos();
    if (lista.length && lista[0].h === handle) return;

    function guardar(pieza) {
      if (!pieza || !pieza.h) return;
      var otros = leerVistos().filter(function (x) { return x.h !== pieza.h; });
      try { localStorage.setItem(CLAVE, JSON.stringify([pieza].concat(otros).slice(0, TOPE_VISTOS))); }
      catch (e) {}
    }

    // Camino barato: el bloque "Arma tu look" ya imprimio estos datos.
    var isla = document.querySelector('[data-zph-fijo]');
    if (isla) {
      try {
        var d = JSON.parse(isla.textContent);
        if (d.h && (d.v || []).length) {
          var v0 = disponibles(d)[0] || d.v[0];
          guardar({ h: d.h, t: d.t, p: v0.p, img: d.img, u: d.u || ('/products/' + d.h), v: d.v });
          return;
        }
      } catch (e) {}
    }

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (pd) {
        var f = pd.featured_image || (pd.images || [])[0] || '';
        if (f) f += (f.indexOf('?') >= 0 ? '&' : '?') + 'width=400';
        guardar({
          h: pd.handle, t: pd.title, p: pd.price, img: f, u: '/products/' + pd.handle,
          v: (pd.variants || []).map(function (v) { return aVariante(v, idxOpciones(pd)); })
        });
      })
      .catch(function () {});
  }

  /* --- barra de envio gratis -------------------------------------------- */
  function pintarEnvio(cajon, carrito) {
    /* LA BARRA VA COMO PRIMER HIJO DE .t4s-drawer__wrap, no de
     * .t4s-drawer__main. Se probo con main y salia DEBAJO de los productos: la
     * lista no siempre esta dentro de main, asi que "el primer hijo de main" no
     * garantiza "arriba". El wrap es el cuerpo entero del cajon -- justo debajo
     * de la cabecera -- y ahi no hay ambiguedad. */
    var sitio = cajon.querySelector('.t4s-drawer__wrap') ||
                cajon.querySelector('.t4s-drawer__main');
    if (!sitio) return;
    var caja = cajon.querySelector('.zph-ship');

    /* CON EL CARRITO VACIO LA BARRA SE QUEDA, informando el umbral. Antes se
     * quitaba, y eso estaba mal por dos razones: el cajon se veia vacio del todo
     * (se lee como que algo no cargo) y se perdia la unica ocasion de decir
     * desde cuanto sale gratis el envio, que es justo cuando aun no ha puesto
     * nada. Lo que NO se hace es usar el atributo hidden: eso dejaba dentro el
     * importe de la vez anterior y podia asomar antes del correcto. */
    if (!caja) {
      caja = document.createElement('div');
      caja.className = 'zph-ship';
      caja.innerHTML = '<p class="zph-ship__t"></p>' +
                       '<div class="zph-ship__bar"><span class="zph-ship__fill"></span></div>';
      sitio.insertBefore(caja, sitio.firstChild);
    } else if (caja.parentElement !== sitio || caja.previousElementSibling) {
      // Si el tema la desplazo al rehacer el cajon, vuelve arriba.
      sitio.insertBefore(caja, sitio.firstChild);
    }

    var falta = META - carrito.total_price;
    var txt = caja.querySelector('.zph-ship__t');
    var fill = caja.querySelector('.zph-ship__fill');
    var nuevoTxt, nuevoAncho, ok = false;

    if (!carrito.item_count) {
      nuevoTxt = 'Envío gratis desde <b>' + plata(META) + '</b>.';
      nuevoAncho = '0%';
    } else if (falta <= 0) {
      ok = true;
      nuevoTxt = '<b>Tienes envío gratis.</b>';
      nuevoAncho = '100%';
    } else {
      nuevoTxt = 'Te faltan <b>' + plata(falta) + '</b> para el envío gratis.';
      nuevoAncho = Math.max(2, Math.min(100, carrito.total_price / META * 100)).toFixed(1) + '%';
    }
    // Se escribe solo si cambia: escribir siempre es lo que hace que titile.
    if (txt.innerHTML !== nuevoTxt) txt.innerHTML = nuevoTxt;
    if (fill.style.width !== nuevoAncho) fill.style.width = nuevoAncho;
    caja.classList.toggle('is-ok', ok);
  }

  /* --- recomendados ----------------------------------------------------- */
  function tarjeta(p) {
    var a = document.createElement('div');
    a.className = 'zph-rec__c';
    a.setAttribute('data-h', p.h);
    a.innerHTML =
      '<a class="zph-rec__foto" href="' + (p.u || ('/products/' + p.h)) + '">' +
        '<img loading="lazy" alt=""></a>' +
      '<a class="zph-rec__n" href="' + (p.u || ('/products/' + p.h)) + '"></a>' +
      '<span class="zph-rec__p"></span>' +
      '<button type="button" class="zph-rec__add" data-zph-add>Añadir</button>' +
      '<div class="zph-rec__pick" hidden></div>';
    var img = a.querySelector('img');
    /* SOLO SE PONE src SI HAY FOTO. Con src="" el navegador resuelve la cadena
     * vacia contra la URL de la pagina y se descarga LA PAGINA ENTERA como si
     * fuera una imagen: seis tarjetas sin foto son seis descargas del HTML. Hay
     * entradas antiguas de zph_vistos sin foto, asi que pasaba de verdad. */
    if (p.img) img.src = p.img;
    img.alt = p.t || '';
    a.querySelector('.zph-rec__n').textContent = p.t || '';
    a.querySelector('.zph-rec__p').textContent = plata(p.p || 0);
    return a;
  }

  /* Se guarda el catalogo de lo que se pinto para que el selector de talla no
   * tenga que volver a pedir nada. */
  var pintadas = {};

  function pintarRec(cajon, titulo, piezas) {
    var scroll = cajon.querySelector('.t4s-drawer__scroll') ||
                 cajon.querySelector('.t4s-drawer__main');
    if (!scroll) return;

    var caja = scroll.querySelector('.zph-rec');
    if (!piezas.length) { if (caja) caja.remove(); return; }

    var firmaNueva = titulo + '::' + piezas.map(function (p) { return p.h; }).join(',');

    /* SI YA ESTA PINTADO LO MISMO, NO SE TOCA NADA. Rehacer la fila reinicia su
     * desplazamiento y hace que titile; era la causa de los dos sintomas. */
    if (caja && caja.getAttribute('data-firma') === firmaNueva) return;

    piezas.forEach(function (p) { pintadas[p.h] = p; });

    if (!caja) {
      caja = document.createElement('div');
      caja.className = 'zph-rec';
      caja.innerHTML = '<p class="zph-rec__h"></p><div class="zph-rec__row"></div>';
      scroll.appendChild(caja);
    }
    caja.setAttribute('data-firma', firmaNueva);
    caja.querySelector('.zph-rec__h').textContent = titulo;
    var row = caja.querySelector('.zph-rec__row');
    row.innerHTML = '';
    piezas.slice(0, 6).forEach(function (p) { row.appendChild(tarjeta(p)); });
  }

  function aPieza(p) {
    var f = p.featured_image || (p.images || [])[0] || '';
    if (f && typeof f === 'object') f = f.src || '';
    if (f) f += (f.indexOf('?') >= 0 ? '&' : '?') + 'width=400';
    var ix = idxOpciones(p);
    var vs = (p.variants || []).map(function (v) {
      var x = aVariante(v, ix); x.p = aCent(v.price); return x;
    });
    var disp = vs.filter(function (x) { return x.a; })[0] || vs[0];
    return {
      h: p.handle, t: p.title, p: p.price != null ? aCent(p.price) : (disp ? disp.p : 0),
      img: f, u: '/products/' + p.handle, v: vs
    };
  }

  /* LOS RECOMENDADOS TAMBIEN SE MUESTRAN CON EL CARRITO VACIO. Antes se
   * quitaban, y eso dejaba el cajon en blanco: la referencia (nude-project) los
   * mantiene incluso sin articulos, y es justo cuando mas sirven.
   *
   * Tres fuentes, en este orden:
   *   1. lo que el visitante ya vio (zph_vistos), quitando lo que ya esta en el
   *      carrito -- es lo que de verdad le interesa;
   *   2. las recomendaciones de Shopify a partir del primer producto del
   *      carrito, que solo existen si hay algo dentro;
   *   3. con el carrito vacio y sin historial, la coleccion de novedades. */
  var COLECCION_RESERVA = 'nuevo';

  /* 2026-10-06 (auditoria 360): con el carrito LLENO van primero los
   * complementos de lo que ya eligio ("Combina con tu seleccion"), que suben el
   * ticket; "Lo que viste" queda de respaldo. Antes iba primero "Lo que viste" y
   * recomendaba la misma prenda recien anadida. Y nunca se propone la prenda de
   * la ficha que se esta viendo. */
  function recomendar(cajon, carrito) {
    var enCarrito = {};
    (carrito.items || []).forEach(function (i) { enCarrito[i.handle] = true; });
    var aqui = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (aqui) enCarrito[aqui] = true;

    var vistos = leerVistos().filter(function (p) { return p.h && !enCarrito[p.h]; });
    function conVistos() {
      if (!vistos.length) return false;
      pintarRec(cajon, 'Lo que viste', vistos);
      return true;
    }

    if (carrito.item_count) {
      fetch('/recommendations/products.json?product_id=' + carrito.items[0].product_id + '&limit=8',
            { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          /* Sin talla ni color = bono de regalo u otra pieza que no "combina". */
          var ps = (d.products || [])
            .filter(function (p) {
              var ix = idxOpciones(p);
              return p.available && !enCarrito[p.handle] && (ix.ti >= 0 || ix.ci >= 0);
            })
            .map(aPieza);
          if (ps.length) pintarRec(cajon, 'Combina con tu selección', ps);
          else if (!conVistos()) pintarRec(cajon, 'Combina con tu selección', []);
        })
        .catch(function () { conVistos(); });
      return;
    }

    if (conVistos()) return;

    fetch('/collections/' + COLECCION_RESERVA + '/products.json?limit=6', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = (d.products || [])
          .filter(function (p) { return (p.variants || []).some(function (v) { return v.available; }); })
          .map(aPieza);
        pintarRec(cajon, 'Recién llegado', ps);
      })
      .catch(function () {});
  }

  /* --- refrescar el cajon con el del servidor ---------------------------
   * Se le pasa el HTML de la seccion si ya se tiene (la respuesta de
   * /cart/add.js lo trae) y si no se pide. Ver la nota 2 de la cabecera: por
   * seccion, NUNCA trayendose la pagina completa. */
  function traerSeccion() {
    return fetch('/?sections=' + SECCION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { return j[SECCION] || ''; });
  }

  function ponerSeccion(html) {
    if (!html) return false;
    var cajon = document.querySelector('#t4s-mini_cart');
    var actual = cajon && cajon.querySelector('.t4s-drawer__wrap');
    if (!actual) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nuevo = doc.querySelector('.t4s-drawer__wrap');
    if (!nuevo) return false;
    /* Solo el cuerpo: la cabecera no cambia y reemplazarla se llevaria el boton
     * de cerrar, que el tema engancha al abrir. Lo mio (barra y recomendados) se
     * va en el reemplazo a proposito: lo repinta el refresco de despues, ya con
     * los numeros del cajon nuevo. */
    actual.innerHTML = nuevo.innerHTML;
    return true;
  }

  function refrescarSeccion(html) {
    // El HTML que viene gratis con la respuesta de /cart/add.js no gasta cupo.
    if (!html) {
      if (secciones >= TOPE_SECCION) return Promise.resolve(false);
      secciones++;
    }
    var p = html ? Promise.resolve(html) : traerSeccion();
    return p.then(function (h) { return ponerSeccion(h); })
      .then(function (ok) {
        ultimaFirma = '';
        refrescar();
        return ok;
      })
      .catch(function () {});
  }

  /* SE COMPARA LO PINTADO CON EL CARRITO DE VERDAD. Esta es la pieza que arregla
   * el sintoma de fondo: el cajon no se refresca solo, asi que si la lista se
   * quedo vieja hay que pedirla. Se compara por numero de filas y por el importe
   * del total (solo digitos, que el tema escribe "$508.000 COP"). Si no hay
   * cuerpo todavia no hay nada que este viejo: se espera al tema. */
  function desfasado(cajon, c) {
    if (!cajon.querySelector('.t4s-mini_cart__items, .t4s-when-cart-emty')) return false;
    var filas = cajon.querySelectorAll('.t4s-mini_cart__item').length;
    if (filas !== (c.items || []).length) return true;
    var el = cajon.querySelector('.t4s-cart-total .t4s-text-right');
    if (!el) return false;
    return el.textContent.replace(/\D+/g, '')
             .indexOf(String(Math.round(c.total_price / 100))) < 0;
  }

  /* --- anadir desde el cajon -------------------------------------------
   * Si la prenda tiene una sola variante disponible se anade directo. Si tiene
   * varias, se abre el selector: talla siempre, y color solo si de verdad hay
   * mas de uno (hoy cada producto es de un color, asi que casi nunca aparece;
   * cuando entre la Fase 3 de la migracion, aparecera solo). */
  /* LAS VARIANTES SE PIDEN AL VUELO SI FALTAN, y esto no es un adorno: las
   * primeras versiones guardaban en zph_vistos solo nombre, precio y foto. Con
   * esas entradas antiguas disponibles() devolvia vacio y el boton Anadir era un
   * clic muerto. Pedirlas aqui arregla el historial viejo sin borrarselo. */
  function conVariantes(p) {
    if ((p.v || []).length) return Promise.resolve(p);
    return fetch('/products/' + p.h + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (pd) {
        p.v = (pd.variants || []).map(function (v) { return aVariante(v, idxOpciones(pd)); });
        pintadas[p.h] = p;
        return p;
      });
  }

  function opciones(p, cual) {
    var vistos = {}, out = [];
    disponibles(p).forEach(function (v) {
      var k = cual === 'c' ? v.c : v.s;
      if (!k || vistos[k]) return;
      vistos[k] = true; out.push(k);
    });
    return out;
  }

  function abrirSelector(card, p) {
    var pick = card.querySelector('.zph-rec__pick');
    var tallas = opciones(p, 's');
    var colores = opciones(p, 'c');
    var html = '';
    if (colores.length > 1) {
      html += '<div class="zph-rec__opt" data-opt="c">' + colores.map(function (c) {
        return '<button type="button" data-v="' + c.replace(/"/g, '') + '">' + c + '</button>';
      }).join('') + '</div>';
    }
    html += '<div class="zph-rec__opt" data-opt="s">' + tallas.map(function (s) {
      return '<button type="button" data-v="' + s.replace(/"/g, '') + '">' + s + '</button>';
    }).join('') + '</div>';
    pick.innerHTML = html;
    pick.hidden = false;
    card.classList.add('is-picking');
  }

  function varianteElegida(card, p) {
    var pick = card.querySelector('.zph-rec__pick');
    var gs = pick.querySelector('[data-opt="s"] .is-on');
    var gc = pick.querySelector('[data-opt="c"] .is-on');
    var s = gs ? gs.getAttribute('data-v') : null;
    var c = gc ? gc.getAttribute('data-v') : null;
    var hayColor = !!pick.querySelector('[data-opt="c"]');
    if (!s || (hayColor && !c)) return null;
    return disponibles(p).filter(function (v) {
      return v.s === s && (!hayColor || v.c === c);
    })[0] || null;
  }

  function anadir(card, variante) {
    var btn = card.querySelector('.zph-rec__add');
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';
    /* sections en el cuerpo: la respuesta trae el cajon ya renderizado con el
     * articulo dentro, asi que se actualiza sin una segunda peticion. */
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variante.i, quantity: 1 }], sections: SECCION })
    })
      .then(function (r) { if (!r.ok) throw new Error('no'); return r.json(); })
      .then(function (res) {
        return refrescarSeccion(res && res.sections ? res.sections[SECCION] : '');
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Reintentar'; });
  }

  function conectarRec(cajon) {
    if (cajon.getAttribute('data-zph-rec-on')) return;
    cajon.setAttribute('data-zph-rec-on', '1');

    cajon.addEventListener('click', function (ev) {
      var card = ev.target.closest ? ev.target.closest('.zph-rec__c') : null;
      if (!card) return;
      var p = pintadas[card.getAttribute('data-h')];
      if (!p) return;

      if (ev.target.closest('[data-zph-add]')) {
        ev.preventDefault();
        var btn = card.querySelector('.zph-rec__add');
        var yaElige = card.classList.contains('is-picking');
        btn.disabled = true;
        conVariantes(p)
          .then(function (pp) {
            btn.disabled = false;
            var d = disponibles(pp);
            if (!d.length) { btn.textContent = 'Agotado'; btn.disabled = true; return; }
            if (d.length === 1) { anadir(card, d[0]); return; }
            if (yaElige) {
              var v = varianteElegida(card, pp);
              if (v) anadir(card, v);
            } else {
              abrirSelector(card, pp);
            }
          })
          .catch(function () { btn.disabled = false; btn.textContent = 'Reintentar'; });
        return;
      }

      var chip = ev.target.closest('.zph-rec__opt button');
      if (chip) {
        ev.preventDefault();
        [].slice.call(chip.parentElement.children).forEach(function (b) { b.classList.remove('is-on'); });
        chip.classList.add('is-on');
        var v2 = varianteElegida(card, p);
        var btn2 = card.querySelector('.zph-rec__add');
        btn2.textContent = v2 ? 'Añadir' : 'Elige talla';
      }
    });
  }

  /* --- terminos y condiciones -------------------------------------------
   * SOLO SE MARCA, Y UNA VEZ POR CASILLA. Antes se lanzaba ademas un evento
   * change, y eso es meter la mano en el codigo del carrito del tema, que puede
   * responder rehaciendo el cajon. Como al rehacerlo la casilla vuelve sin
   * marcar, se marcaba, se relanzaba el evento, el tema rehacia... un ida y
   * vuelta que no para. Marcar la propiedad basta para que el formulario la
   * envie marcada, que es lo unico que se necesitaba. */
  function sinTerminos(cajon) {
    var ck = cajon.querySelector('#cart_agree');
    if (!ck || ck.getAttribute('data-zph-ok')) return;
    ck.setAttribute('data-zph-ok', '1');
    ck.checked = true;
  }

  /* --- refresco --------------------------------------------------------- */
  var pidiendo = false, ultimaFirma = '', abierto = false, sanada = '', otraVez = false;

  /* PRESUPUESTO. Los observadores estan vivos y se reenganchan (nota 5), asi que
   * cualquier reaccion del tema a algo que haga este archivo podria convertirse
   * en un ida y vuelta sin fin. Con un tope, lo peor que puede pasar es que el
   * cajon deje de refrescarse solo -- se sigue pudiendo usar -- en vez de dejar
   * la pestana colgada. Los numeros son holgados: abrir el cajon gasta uno o
   * dos. */
  var TOPE_REFRESCOS = 60, gastados = 0;
  var TOPE_SECCION = 4, secciones = 0;

  function firmaDe(c) {
    return c.item_count + '|' + c.total_price + '|' +
           (c.items || []).map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',');
  }

  /* SE PINTA TAMBIEN AL CARGAR, SIN ESPERAR A QUE ABRAN EL CAJON.
   * Se intento lo contrario -- no hacer nada hasta detectar la apertura -- y
   * salio mal: no se pintaba NADA nunca, ni barra ni recomendados, porque la
   * deteccion de "lo abrieron" no era fiable (ver el observador de clases en
   * arrancar()). Cuando la unica puerta de entrada puede fallar, no puede ser la
   * unica puerta de entrada. Cuesta una lectura de /cart.js por pagina y, a
   * cambio, para que no se vea la barra tienen que fallar las tres vias. */
  function refrescar() {
    var cajon = document.querySelector('#t4s-mini_cart');
    if (!cajon) return;
    /* 2026-10-06: si ya hay una lectura en curso, la nueva NO se descarta: queda
     * en cola. Antes se perdia, y el cajon se quedaba pintado con el carrito de
     * antes de anadir (barra "envio gratis desde" vacia y recomendando la prenda
     * recien anadida). */
    if (pidiendo) { otraVez = true; return; }
    if (++gastados > TOPE_REFRESCOS) return;
    pidiendo = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        sinTerminos(cajon);
        vigilar(cajon);
        var f = firmaDe(c);

        /* AUTOCORRECCION. Si lo pintado no cuadra con el carrito, se pide el
         * cajon al servidor y se vuelve por aqui. Solo con el cajon ya tocado
         * (abierto): con el cajon cerrado nadie ve la lista vieja. Y una sola
         * vez por estado del carrito (sanada), que si no seria un bucle cuando
         * el tema y /cart.js no se puedan cuadrar nunca -- por ejemplo con un
         * regalo automatico que suma una fila que el carrito no cuenta. */
        if (abierto && sanada !== f && desfasado(cajon, c)) {
          sanada = f;
          pidiendo = false;
          refrescarSeccion();
          return;
        }

        /* La barra existe SIEMPRE que haya sitio donde ponerla, asi que su
         * ausencia es la senal fiable de "el tema rehizo el cajon y se llevo lo
         * mio". Si el carrito no cambio y la barra sigue ahi, no se toca el DOM:
         * primera de las tres barreras contra el parpadeo. */
        var faltaBarra = !cajon.querySelector('.zph-ship');
        if (f === ultimaFirma && !faltaBarra) return;
        ultimaFirma = f;
        pintarEnvio(cajon, c);
        recomendar(cajon, c);
        conectarRec(cajon);
      })
      .catch(function () {})
      .then(function () {
        pidiendo = false;
        if (otraVez) { otraVez = false; pedir(); }
      });
  }

  /* --- vigilancia -------------------------------------------------------
   * Se llama en cada refresco, no solo al arrancar. Ver la nota 5: colgarse una
   * vez dejaba los observadores en nodos que el tema ya habia reemplazado, y la
   * barra no volvia a aparecer nunca. */
  var visto = (typeof WeakSet === 'function') ? new WeakSet() : null;
  var t = null;
  function pedir() { clearTimeout(t); t = setTimeout(refrescar, 200); }

  function ajeno(ms) {
    return ms.some(function (m) {
      return [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes))
        .some(function (n) {
          return n.nodeType === 1 && !/zph-ship|zph-rec/.test(String(n.className));
        });
    });
  }

  function colgar(nodo) {
    if (!nodo || !visto || visto.has(nodo)) return;
    visto.add(nodo);
    // Sin subtree A PROPOSITO (nota 4): con subtree, lazysizes tocando mis
    // propias fotos disparaba el repintado, y de ahi el bucle del parpadeo.
    new MutationObserver(function (ms) {
      if (ajeno(ms)) { ultimaFirma = ''; pedir(); }
    }).observe(nodo, { childList: true });
  }

  function vigilar(cajon) {
    colgar(cajon);
    colgar(cajon.querySelector('.t4s-drawer__wrap'));
    colgar(cajon.querySelector('.t4s-drawer__main'));
    colgar(cajon.querySelector('.t4s-drawer__scroll'));
  }

  /* Repaso al abrir: tres comprobaciones y se acaba. SOLO LEE; unicamente pide
   * un refresco si de verdad falta la barra, asi que no puede hacer titilar
   * nada. Es el cinturon por si el tema rehace el cajon de una forma que los
   * observadores no vean. */
  function repasar(cajon) {
    [250, 700, 1500].forEach(function (ms) {
      setTimeout(function () {
        vigilar(cajon);
        /* 2026-10-06: se relee el carrito siempre, no solo si falta la barra. La
         * barra podia estar pintada con el carrito de antes de anadir y, como
         * existia, nadie la corregia. Releer no titila: refrescar() solo repinta
         * si el carrito cambio. */
        if (!cajon.querySelector('.zph-ship')) ultimaFirma = '';
        pedir();
      }, ms);
    });
  }

  function arrancar() {
    var cajon = document.querySelector('#t4s-mini_cart');
    if (!cajon) return false;

    anotarVisto();
    vigilar(cajon);
    refrescar();

    /* CUALQUIER CAMBIO DE CLASE EN EL CAJON CUENTA COMO "lo abrieron", y NO SE
     * MIRA t4s-dn: conviene no volver a mirarlo. Se dio por hecho que el tema
     * abre el cajon quitando esa clase y se puso como UNICA condicion para
     * arrancar; resultado: no se pintaba nada nunca, porque el tema lo abre de
     * otra forma. Lo unico comprobado es que las clases del cajon cambian cuando
     * el tema lo abre o lo cierra, y con eso basta. */
    new MutationObserver(function (ms) {
      if (!ms.some(function (m) { return m.target === cajon; })) return;
      abierto = true;
      repasar(cajon);
      pedir();
    }).observe(cajon, { attributes: true, attributeFilter: ['class'] });

    /* TERCERA VIA: el clic en cualquier cosa que lleve al carrito. Sobra si el
     * observador de arriba funciona, y es justo lo que hacia falta el dia que no
     * funciono. */
    document.addEventListener('click', function (ev) {
      if (!ev.target.closest) return;
      if (ev.target.closest('a[href*="/cart"],[data-cart-sidebar],[data-open-mini-cart],[data-drawer-options],.t4s-mini_cart__btn')) {
        abierto = true;
        pedir();
      }
    }, true);

    // El tema cambia cantidades y quita lineas con sus propios botones.
    cajon.addEventListener('click', function (ev) {
      if (!ev.target.closest) return;
      if (ev.target.closest('.zph-rec')) return;      // lo mio no cuenta
      if (ev.target.closest('[data-action-remove],[data-quantity-selector],.t4s-mini_cart__remove')) {
        setTimeout(function () { ultimaFirma = ''; sanada = ''; refrescar(); }, 700);
      }
    });

    /* El resto del sitio tambien mueve el carrito: la ficha, "Arma tu look" y
     * los botones rapidos del tema. Ninguno avisa, asi que se revisa al volver a
     * la pestana y al abrir el cajon (arriba). Con la autocorreccion de
     * refrescar(), eso basta para que la lista nunca se quede vieja. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { sanada = ''; pedir(); }
    });

    return true;
  }

  /* 2026-10-06: CUALQUIER CAMBIO DEL CARRITO POR RED avisa al cajon, venga de
   * donde venga (boton de la ficha, "Arma tu look", botones rapidos del tema).
   * Se observa la respuesta de fetch y de XMLHttpRequest a /cart/add, change,
   * update y clear, y al terminar se relee el carrito. */
  function vigilarRed() {
    var re = /\/cart\/(add|change|update|clear)/;
    function avisar() { sanada = ''; ultimaFirma = ''; pedir(); }
    if (window.fetch && !window.fetch.__zph) {
      var f0 = window.fetch;
      var f1 = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = f0.apply(this, arguments);
        if (re.test(url)) p.then(avisar, function () {});
        return p;
      };
      f1.__zph = true;
      window.fetch = f1;
    }
    var X = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (X && !X.__zph) {
      var open0 = X.open, send0 = X.send;
      X.open = function (m, u) { this.__zphUrl = u; return open0.apply(this, arguments); };
      X.send = function () {
        if (re.test(String(this.__zphUrl || ''))) this.addEventListener('loadend', avisar);
        return send0.apply(this, arguments);
      };
      X.__zph = true;
    }
  }
  vigilarRed();

  var n = 0;
  function esperar() {
    if (arrancar() || ++n > 40) return;
    setTimeout(esperar, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', esperar);
  else esperar();
})();
